import styled from 'styled-components';
import { P14 } from './P14';
import { customTextColor } from '../../../constants/CommonStyles';

export const P14M = styled(P14)`
  font-weight: 500;
  ${customTextColor}
`;
